import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import FormInputField from './FormInputField'

class PasswordField extends React.Component {
  showAsInvalid(message = null) {
    this.componentField.showAsInvalid(message)
  }

  render() {
    const {
      inputId,
      inputName,
      labelText,
      onChange,
      t,
      value
    } = this.props

    return (
      <FormInputField
        inputId={inputId}
        inputName={inputName}
        inputType="password"
        labelText={labelText || t('fields.password', { ns: 'devise' })}
        onChange={(event) => onChange(event)}
        ref={(component) => { this.componentField = component }}
        value={value}
      />
    )
  }
}

PasswordField.propTypes = {
  inputId: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
}

PasswordField.defaultProps = {
  labelText: null
}

export default withTranslation('devise', { withRef: true })(PasswordField)
